import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { flow, makeObservable, observable, set } from "mobx";
import { request } from "../utils/request.js";
import { locationRestStatsGet } from "../wp-api/stats.get.js";
class StatsStore {
    busy = false;
    deletableSpaceFormat = "0 B";
    deletableSpace = 0;
    newThumbnailsCount = 0;
    imagesCount = 0;
    totalCount = 0;
    sizes = {};
    schema = "";
    rootStore;
    constructor(rootStore){
        this.rootStore = rootStore;
        makeObservable(this);
    }
    fetch = flow(function*() {
        this.busy = true;
        try {
            const result = yield request({
                location: locationRestStatsGet
            });
            set(this, result);
        } catch (e) {
            console.log(e);
        } finally{
            this.busy = false;
        }
    });
}
_ts_decorate([
    observable
], StatsStore.prototype, "busy", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "deletableSpaceFormat", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "deletableSpace", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "newThumbnailsCount", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "imagesCount", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "totalCount", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], StatsStore.prototype, "sizes", void 0);
_ts_decorate([
    observable
], StatsStore.prototype, "schema", void 0);
export { StatsStore };
